const KEY = 'ado-liveness-v8-2024';

const encode = (str) => btoa(unescape(encodeURIComponent(str)));
const decode = (str) => decodeURIComponent(escape(atob(str)));

const xor = (text, key) => {
    return text.split('').map((c, i) => 
        String.fromCharCode(c.charCodeAt(0) ^ key.charCodeAt(i % key.length))
    ).join('');
};

export const encrypt = (data) => {
    const json = JSON.stringify(data);
    const xored = xor(json, KEY);
    return encode(xored);
};

export const decrypt = (encoded) => {
    const xored = decode(encoded);
    const json = xor(xored, KEY);
    return JSON.parse(json);
};
